<template>
  <div v-html="body">
  </div>

</template>

<script>

import Config from '../Config'

export default {
  name: 'Documentation',
  props: {},
  data: function() {
    return {
      config: Config,
      body: ""
    }
  },
  created: function() {
    var oReq = new XMLHttpRequest();

    oReq.addEventListener("load", () => {
      this.body = oReq.responseText;
    });

    oReq.addEventListener("error", () => {
    });

    oReq.open("GET", this.config.protocol + "://" + this.config.apihost + "/doc");

    oReq.setRequestHeader("x-access-token", "rewaco24");
    oReq.send();

  },
  methods: {
    sendFeatureEnail: function(){
      alert("SEND");
    }
  }
}
</script>

<style>
h3 {
  margin: 40px 0 0;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #42b983;
}

.get {
  background-color: #BCF5A9;
}

.put {
  background-color: #e3b7eb;
}

.tokenrequired {
  background-color: #F5A9BC;
}
</style>
